import { get } from "lodash";
import { Button } from "PFComponents/button";
import InputFieldSet from "PFComponents/text/input_field_set";
import React, { useCallback } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import css from "./header.module.scss";

export const Header = (): JSX.Element => {
  const { t } = useTranslation(["skillsFrameworks", "translation"]);
  const history = useHistory();
  const {
    control,
    formState: { errors, isDirty }
  } = useFormContext();

  const onCancel = useCallback(() => {
    history.goBack();
  }, [history]);

  return (
    <header className={css.header}>
      <Controller
        name="name"
        control={control}
        rules={{
          required: t("skillsFrameworks:edit.errors.required")
        }}
        render={({ field }) => (
          <InputFieldSet
            inputType="text"
            controlledValue
            placeholder={t("skillsFrameworks:edit.newSkillFramework")}
            name={field.name}
            value={field.value}
            error={get(errors, field.name)?.message}
            handleChange={field.onChange}
            handleBlur={field.onBlur}
            classes={{
              inputContainer: css.headerInput
            }}
            maxLength={100}
          />
        )}
      />
      <div className={css.buttons}>
        <Button
          text={t("translation:cancel")}
          type="button"
          kind="tertiary"
          className={css.button}
          onClick={onCancel}
        />
        <Button
          icon="check"
          text={t("translation:save")}
          className={css.button}
          disabled={!isDirty}
          type="submit"
        />
      </div>
    </header>
  );
};
